// Runtime environment configuration.
// Populated by config.js (window.__APP_CONFIG__), which is loaded before the app bundle
// and whose #{...} tokens are substituted per-environment at deploy time.
// Aliased as 'Config' via webpack resolve.alias, so existing `import Config from 'Config'` keeps working.
export default window.__APP_CONFIG__ || {};
